import { localeLoaderMiddleware } from '@opengov/locale/loader';
import { IReportLocale } from '.';

// To keep webpack's dynamic module resolution from dramatically increasing build time,
// each module that provides locale data defines it's own loader
export const localeLoader = (namespace: string, locale: string) =>
  import(/* webpackChunkName: "[request]" */ `../../../src/locale/${namespace}.${locale}.locale.json`).then(
    (result: IReportLocale) => result
  );

export const localeMiddleware = localeLoaderMiddleware('report', localeLoader);
